/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Link_StorefrontInputs */

const en_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Storefront`)
};

const es_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear tienda`)
};

const fr_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une vitrine`)
};

const de_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront erstellen`)
};

const ja_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストアフロントを作成`)
};

const zh_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建店铺`)
};

const ar_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء واجهة متجر`)
};

const id_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Etalase`)
};

const it_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Vetrina`)
};

const ru_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать витрину`)
};

const pt_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Vitrine`)
};

const ko_footer_link_storefront = /** @type {(inputs: Footer_Link_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스토어프론트 만들기`)
};

/**
* | output |
* | --- |
* | "Create Storefront" |
*
* @param {Footer_Link_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_link_storefront = /** @type {((inputs?: Footer_Link_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Link_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_link_storefront(inputs)
	if (locale === "es") return es_footer_link_storefront(inputs)
	if (locale === "fr") return fr_footer_link_storefront(inputs)
	if (locale === "de") return de_footer_link_storefront(inputs)
	if (locale === "ja") return ja_footer_link_storefront(inputs)
	if (locale === "zh") return zh_footer_link_storefront(inputs)
	if (locale === "ar") return ar_footer_link_storefront(inputs)
	if (locale === "id") return id_footer_link_storefront(inputs)
	if (locale === "it") return it_footer_link_storefront(inputs)
	if (locale === "ru") return ru_footer_link_storefront(inputs)
	if (locale === "pt") return pt_footer_link_storefront(inputs)
	return ko_footer_link_storefront(inputs)
});